document.addEventListener('DOMContentLoaded', function() {
  var steps = document.querySelectorAll('.variant-step');
  if (!steps.length) return;

  // Get product JSON (adjust selector as needed)
  var productJsonScript = document.querySelector('[id^="ProductJson-"]');
  if (!productJsonScript) return;
  var product = JSON.parse(productJsonScript.textContent);

  // Store selected values for each step
  var selectedValues = [];
  var selectedVariantIdInput = document.getElementById('selected-variant-id');
  var addToCartButton = document.querySelector('.add-to-cart');
  var hasAvailableVariant = false;

  // Initialize availability states
  function initializeAvailability() {
    steps.forEach(function(step, idx) {
      var swatchInputs = step.querySelectorAll('input[type="radio"].selector');
      swatchInputs.forEach(function(input) {
        var swatchEl = input.closest('.swatch-element');
        
        // Find all variants that have this option value
        var variantsWithThisOption = product.variants.filter(function(v) {
          return v['option' + (idx + 1)] === input.value;
        });
        
        // Check if any of these variants are available
        hasAvailableVariant = variantsWithThisOption.some(function(v) {
          return v.available;
        });
        
        if (hasAvailableVariant) {
          swatchEl.classList.add('is-available');
          swatchEl.classList.remove('soldout');
          input.disabled = false;
        } else {
          swatchEl.classList.add('soldout');
          swatchEl.classList.remove('is-available');
          input.disabled = true;
        }
      });
    });
  }

  // Find the selected variant based on current selections
  function findSelectedVariant() {
    if (selectedValues.length !== product.options.length) {
      return null; // Not all options selected yet
    }
    
    return product.variants.find(function(variant) {
      for (var i = 0; i < selectedValues.length; i++) {
        if (variant['option' + (i + 1)] !== selectedValues[i]) {
          return false;
        }
      }
      return true;
    });
  }

  // Update the Add to Cart button state
  function updateAddToCartButton(variant) {
    if (!addToCartButton) return;
    if (!hasAvailableVariant) return;
    
    if (!variant) {
      // No complete selection yet
      addToCartButton.textContent = 'Please select options';
      addToCartButton.disabled = true;
      addToCartButton.classList.add('disabled', 'outline');
      return;
    }
    
    if (variant.available) {
      // Format price for display
      var price = '';
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        price = Shopify.formatMoney(variant.price, theme.moneyFormat);
      } else {
        // Fallback if Shopify.formatMoney is not available
        price = '$' + (variant.price / 100).toFixed(2);
      }
      
      addToCartButton.textContent = 'Add to Cart | ' + price;
      addToCartButton.disabled = false;
      addToCartButton.classList.remove('disabled', 'outline');
    } else {
      addToCartButton.textContent = 'Sold Out';
      addToCartButton.disabled = true;
      addToCartButton.classList.add('disabled', 'outline');
    }
  }

  // Update the price display
  function updatePriceDisplay(variant) {
    var priceContainer = document.getElementById('product-price');
    if (!priceContainer) return;
    if (!variant) {
      priceContainer.innerHTML = '';
      return;
    }

    // Currency formatting
    var price = '';
    var compareAtPrice = '';
    var savings = '';
    var showSavings = false;
    var showCompare = false;
    var currencyEnable = typeof theme !== 'undefined' && theme.currencyEnable; // Set this in your theme JS if needed

    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      price = currencyEnable
        ? Shopify.formatMoney(variant.price, theme.money_with_currency_format)
        : Shopify.formatMoney(variant.price, theme.moneyFormat);

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareAtPrice = currencyEnable
          ? Shopify.formatMoney(variant.compare_at_price, theme.money_with_currency_format)
          : Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat);

        savings = currencyEnable
          ? Shopify.formatMoney(variant.compare_at_price - variant.price, theme.money_with_currency_format)
          : Shopify.formatMoney(variant.compare_at_price - variant.price, theme.moneyFormat);

        showSavings = true;
        showCompare = true;
      }
    } else {
      price = '$' + (variant.price / 100).toFixed(2);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareAtPrice = '$' + (variant.compare_at_price / 100).toFixed(2);
        savings = '$' + ((variant.compare_at_price - variant.price) / 100).toFixed(2);
        showSavings = true;
        showCompare = true;
      }
    }

    // Build HTML to match product.price.custom.liquid
    var html = '';
    html += '<div class="offers custom">';
    html += '  <div class="price-preview price price-field product-single__price" itemprop="price">';
    html += '    <span class="price-text">' + price + '</span>';
    if (showSavings) {
      html += '    <span class="savings-tag">Save&nbsp;' + savings + '</span>';
    }
    html += '  </div>';
    html += '  <p class="savings' + (showCompare ? '' : ' hidden') + '">';
    html += '    <span>Full retail price</span> ';
    html += '    <span>' + (showCompare ? compareAtPrice : '') + '</span>';
    html += '  </p>';
    html += '</div>';

    priceContainer.innerHTML = html;
  }

  // Initialize on page load
  initializeAvailability();
  updateAddToCartButton(null); // Start with no selection
  // Show price for initial variant on page load
  var initialVariant = null;
  if (selectedVariantIdInput && product && product.variants) {
    initialVariant = product.variants.find(function(v) {
      return v.id == selectedVariantIdInput.value;
    });
  }
  updatePriceDisplay(initialVariant);

  steps.forEach(function(step, idx) {
    var swatchInputs = step.querySelectorAll('input[type="radio"].selector');
    if (!swatchInputs.length) return;

    swatchInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        // Set selected value for this step
        selectedValues[idx] = input.value;

        // Update the label text for this step
        var labelSpan = step.querySelector('.variant-label');
        if (labelSpan) {
          labelSpan.textContent = input.value;
        }

        // Remove .active from all swatches in this step, then add to selected
        swatchInputs.forEach(function(inp) {
          inp.closest('.swatch-element').classList.remove('active');
        });
        input.closest('.swatch-element').classList.add('active');

        // Reset all subsequent steps
        for (var i = idx + 1; i < steps.length; i++) {
          steps[i].style.display = 'none';
          var nextInputs = steps[i].querySelectorAll('input[type="radio"].selector');
          nextInputs.forEach(function(inp) {
            inp.checked = false;
            inp.closest('.swatch-element').classList.remove('active');
          });
          selectedValues[i] = undefined;
        }

        // If not last step, show and filter the next step's swatches
        if (idx + 1 < steps.length) {
          var nextStep = steps[idx + 1];
          var nextInputs = nextStep.querySelectorAll('input[type="radio"].selector');
          var availableOptions = getAvailableOptionsForStep(product, idx + 1, selectedValues.slice(0, idx + 1));
          
          nextInputs.forEach(function(inp) {
            var swatchEl = inp.closest('.swatch-element');
            
            // Check if this option is available for the current selection
            var isOptionAvailable = availableOptions.indexOf(inp.value) !== -1;
            
            if (isOptionAvailable) {
              swatchEl.style.display = '';
              inp.disabled = false;
              
              // Check if any variant with this option value is actually available
              var variantsWithThisOption = product.variants.filter(function(v) {
                var match = true;
                for (var j = 0; j <= idx; j++) {
                  if (v['option' + (j + 1)] !== selectedValues[j]) {
                    match = false;
                    break;
                  }
                }
                return match && v['option' + (idx + 2)] === inp.value;
              });
              
              var hasAvailableVariant = variantsWithThisOption.some(function(v) {
                return v.available;
              });
              
              if (hasAvailableVariant) {
                swatchEl.classList.add('is-available');
                swatchEl.classList.remove('soldout');
              } else {
                swatchEl.classList.add('soldout');
                swatchEl.classList.remove('is-available');
              }
            } else {
              swatchEl.style.display = 'none';
              inp.disabled = true;
              inp.checked = false;
              swatchEl.classList.remove('active');
            }
          });
          nextStep.style.display = '';
        }

        // Check if we have a complete selection
        var selectedVariant = findSelectedVariant();
        if (selectedVariant && selectedVariantIdInput) {
          selectedVariantIdInput.value = selectedVariant.id;
        }
        
        // Update Add to Cart button
        updateAddToCartButton(selectedVariant);
        updatePriceDisplay(selectedVariant);
      });
    });
  });

  function getAvailableOptionsForStep(product, stepIndex, selectedValues) {
    var options = [];
    product.variants.forEach(function(variant) {
      var match = true;
      for (var i = 0; i < stepIndex; i++) {
        if (variant['option' + (i + 1)] !== selectedValues[i]) {
          match = false;
          break;
        }
      }
      if (match && options.indexOf(variant['option' + (stepIndex + 1)]) === -1) {
        options.push(variant['option' + (stepIndex + 1)]);
      }
    });
    return options;
  }
}); 